import React, { useState } from "react";
import { Modal, Badge } from "react-bootstrap";
import "./View_Share_Booking_Modal.css";
import { IDS } from "../../../../utils/IDS";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";

function View_Share_Booking_Modal({ show, onHide, bookingdetails }) {
  const data = bookingdetails;
  const [imgError, setImgError] = useState({});
  if (!data) return null;

  const locations = data?.ShareLocations || [];
  const locationMap = {};
  data?.ShareLocations?.forEach((loc) => {
    locationMap[loc.id] = loc;
  });

  return (
    <Modal show={show} onHide={onHide} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>🚖 Share Booking #{data?.id}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* 🔹 Driver + Vehicle */}
        <div className="card-box">
          <div className="flex-between">
            <div>
              <h5>👨‍✈️ Driver</h5>
              <p>{data?.Driver?.first_name}</p>
              <small>{data?.Driver?.contact_no}</small>
            </div>

            <div>
              <h5>🚗 Vehicle</h5>
              <p>{data?.Vehicle?.name}</p>
              <Badge bg="info">{data?.Vehicle_Category?.name}</Badge>
            </div>
          </div>
        </div>

        {/* 🔹 Timeline Route */}
        <div className="card-box">
          <h5>📍 Route Details</h5>

          <div className="timeline">
            {locations.map((loc, index) => {
              const isFirst = index === 0;
              const isLast = index === locations.length - 1;

              return (
                <div className="timeline-item" key={index}>
                  <div
                    className={`circle ${
                      isFirst ? "start" : isLast ? "end" : "mid"
                    }`}
                  />

                  <div className="content">
                    <div className="location">{loc.location}</div>

                    <div className="meta">
                      ⏰ {new Date(loc.datetime).toLocaleString()}
                    </div>

                    <div className="rate">
                      {isFirst ? "Start" : `₹${loc.rate}`}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="card-box">
          <h6>👥 Passenger Details </h6>

          {data?.SharePassengers?.length ? (
            data.SharePassengers.map((p, i) => {
              const pickup = locationMap[p.pick_location_id];
              const drop = locationMap[p.drop_location_id];

              return (
                <div className="passenger-card" key={i}>
                  {/* LEFT */}
                  <div className="passenger-left">
                    {p.User.profile_photo && !imgError[p?.User.id] ? (
                      <div className="avatar">
                        <img
                          src={IDS?.IMG_URL + p.User.profile_photo}
                          alt="profile"
                          className="avatar-img"
                          onError={() =>
                            setImgError((prev) => ({
                              ...prev,
                              [p?.User?.id]: true,
                            }))
                          }
                        />
                      </div>
                    ) : (
                      <div
                        style={{
                          width: "50px",
                          height: "50px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                        }}
                      >
                        <FontAwesomeIcon icon={faUser} size="2x" />
                      </div>
                    )}

                    <div>
                      <div className="name">
                        {p?.User?.first_name || "Unknown"}
                      </div>
                      <div className="contact">
                        {p?.User?.contact_no || "-"}
                      </div>

                      {/* 📍 Route */}
                      <div className="route">
                        <div className="pickup">
                          📍 {pickup?.location || "N/A"}
                          <div className="time">
                            {pickup?.datetime
                              ? new Date(pickup.datetime).toLocaleString()
                              : ""}
                          </div>
                        </div>

                        <div className="arrow">↓</div>

                        <div className="drop">
                          🏁 {drop?.location || "N/A"}
                          <div className="time">
                            {drop?.datetime
                              ? new Date(drop.datetime).toLocaleString()
                              : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* RIGHT */}
                  <div className="passenger-right">
                    <div className="seat">
                      {p.message && (
                        <>
                          <b>Message: </b>
                          {p.message}
                        </>
                      )}
                    </div>
                    <div className="seat">💺 {p.seat || 1}</div>
                    <div className="amount">₹{p.rate || 0}</div>

                    <span
                      className={`status-badge ${
                        p?.BookingStatus?.name === "Approved"
                          ? "success"
                          : p?.BookingStatus?.name === "Rejected"
                          ? "danger"
                          : "pending"
                      }`}
                    >
                      {p?.BookingStatus?.name || "Pending"}
                    </span>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="empty">🚫 No passengers added yet</div>
          )}
        </div>

        {/* 🔹 Summary */}
        <div className="card-box">
          <h5>📊 Booking Info</h5>

          <div className="grid">
            <div>
              <strong>Date:</strong>
              <p>{new Date(data.start_date).toLocaleString()}</p>
            </div>

            <div>
              <strong>Status:</strong>
              <p>
                <Badge bg="success">{data?.BookingStatus?.name}</Badge>
              </p>
            </div>

            <div>
              <strong>Total Seats:</strong>
              <p>{data.total_passenger}</p>
            </div>

            <div>
              <strong>Comment:</strong>
              <p>{data.comment}</p>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default View_Share_Booking_Modal;
